import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import HeaderFour from '../header/HeaderFour';
import ProjectDetails from './breadcrumb/ProjectDetails';
import Footer from '../elements/Footer';
import HeaderNew from '../header/HeaderNew';

function PortfolioSix() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const [portfolio, setPortfolio] = useState(null);

    useEffect(() => {
        if (id) {
            axios.get(`https://solanthegroup.com/admin/api/portfolios/${id}`)
                .then(response => {
                    if (response.data.length > 0) {
                        setPortfolio(response.data[0]);
                    }
                })
                .catch(error => console.error('Error fetching portfolio data:', error));
        }
    }, [id]);

    if (!portfolio) {
        return <div></div>;
    }

    return (
        <div>
            <HeaderNew/>
            {/* <ProjectDetails /> */}
            <div className="projects-details-area tmp-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="projects-details-inner">
                                <div className="thumbnail position-relative">
                                    <img className="w-100 h-100" src={`https://solanthegroup.com/admin/${portfolio.banner}`} alt={portfolio.title} />
                                </div>
                                <div className="clients-projects-details">
                                    <div className="clients-details-inner">
                                        <h3 className="title text-center">CLIENT PROJECT DETAILS</h3>
                                        <div className="single-projects-details">
                                            <div className="info"><div className="icon"><i className="fa-solid fa-user" /></div><div className="content"><h4 className="subtitle">Clients:</h4><h5 className="category">{portfolio.client}</h5></div></div>
                                            <div className="info"><div className="icon"><i className="fa-sharp fa-light fa-layer-group" /></div><div className="content"><h4 className="subtitle">Category:</h4><h5 className="category">{portfolio.categories.string}</h5></div></div>
                                            <div className="info"><div className="icon"><i className="fa-light fa-calendar-days" /></div><div className="content"><h4 className="subtitle">Date:</h4><h5 className="category">{portfolio.date}</h5></div></div>
                                            <div className="info"><div className="icon"><i className="fa-regular fa-map-location" /></div><div className="content"><h4 className="subtitle">Address:</h4><h5 className="category">{portfolio.address}</h5></div></div>
                                        </div>
                                    </div>
                                    <div className="projects-details-wrapper">
                                        <h3 className="title">{portfolio.title}</h3>
                                        <div dangerouslySetInnerHTML={{ __html: portfolio.description }} />
                                    </div>
                                    <div className="projects-details-wrapper">
                                        <h3 className="title">{portfolio.challenge_title}</h3>
                                        <div dangerouslySetInnerHTML={{ __html: portfolio.challenge_description }} />
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="challenge-details"><div className="icon"><i className="fa-solid fa-check" /></div><p className="description">{portfolio.challenge_single_check_one}</p></div>
                                                <div className="challenge-details"><div className="icon"><i className="fa-solid fa-check" /></div><p className="description">{portfolio.challenge_single_check_two}</p></div>
                                                <div className="challenge-details"><div className="icon"><i className="fa-solid fa-check" /></div><p className="description">{portfolio.challenge_single_check_three}</p></div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="challenge-details"><div className="icon"><i className="fa-solid fa-check" /></div><p className="description">{portfolio.challenge_single_check_four}</p></div>
                                                <div className="challenge-details"><div className="icon"><i className="fa-solid fa-check" /></div><p className="description">{portfolio.challenge_single_check_five}</p></div>
                                                <div className="challenge-details"><div className="icon"><i className="fa-solid fa-check" /></div><p className="description">{portfolio.challenge_single_check_six}</p></div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                <div className="thumbnail">
                                                    <img src={`https://solanthegroup.com/admin/${portfolio.gallery1}`} alt="project details" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                <div className="thumbnail">
                                                    <img src={`https://solanthegroup.com/admin/${portfolio.gallery2}`} alt="project details" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default PortfolioSix;
